import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)


	return {
		"id": id,
		"elements": [{
			"type": "shape",
			"id": "gVvN7hCvJj",
			"width": 532.38,
			"height": 458.95,
			"left": 22.95,
			"top": 89.06,
			"viewBox": [
				532.38,
				458.95
			],
			"path": "M 266.19 0 L 0 458.95 L 532.38 458.95 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 200,
			"outline": {
				"color": "#5B9BD5",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial Narrow;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false,
			"shadow": {
				"h": 0.1,
				"v": 1.88,
				"blur": 38.54,
				"color": "rgb(150, 150, 150)"
			},
			"pathFormula": "triangle",
			"keypoint": 0.5
		},
		{
			"type": "text",
			"id": "Bgl0JivocS",
			"width": 295.8,
			"height": 131.125,
			"left": 161.8,
			"top": 179.69,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "rgba(127,127,127,1)",
			"content": `<p style=\"\"><span style=\"font-size: 44.9px;\"><span style=\"font-family: +mn-lt;\">PART</span></span></p><p style=\"\"><strong><span style=\"font-size: 61.22px;\"><span style=\"font-family: +mn-lt;\">&nbsp; &nbsp; &nbsp;${serial}</span></span></strong></p>`,
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "text",
			"id": "WwMpG0-sJf",
			"width": 341.27006153117975,
			"height": 60,
			"left": 541.7313667021655,
			"top": 295.50795053839784,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "rgba(127,127,127,1)",
			"content": `<p style=\"\"><strong><span style=\"font-size: 40px;\"><span style=\"font-family: Arial Narrow;\">${title}</span></span></strong></p>`,
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "shape",
			"id": "n5WZHWyHhE",
			"width": 307.04,
			"height": 264.69,
			"left": 683.51,
			"top": -106.17,
			"viewBox": [
				307.04,
				264.69
			],
			"path": "M 153.52 0 L 0 264.69 L 307.04 264.69 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 270,
			"outline": {
				"color": "#5B9BD5",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial Narrow;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false,
			"shadow": {
				"h": 0.1,
				"v": 1.88,
				"blur": 38.54,
				"color": "rgb(150, 150, 150)"
			},
			"pathFormula": "triangle",
			"keypoint": 0.5
		},
		{
			"type": "shape",
			"id": "KhPyMsicqz",
			"width": 307.04,
			"height": 264.69,
			"left": 830.99,
			"top": 244.94,
			"viewBox": [
				307.04,
				264.69
			],
			"path": "M 153.52 0 L 0 264.69 L 307.04 264.69 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 355,
			"outline": {
				"color": "#5B9BD5",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial Narrow;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false,
			"shadow": {
				"h": 0.1,
				"v": 1.88,
				"blur": 38.54,
				"color": "rgb(150, 150, 150)"
			},
			"pathFormula": "triangle",
			"keypoint": 0.5
		}
		],
		background
	};

}